import Map from "../map/Map";
import { getPropertiesPopup } from "./PropertiesMapPopup";
import { scrollToSelectedLocation } from "../map/scroll-to-place";

class PropertiesMap {
    constructor(DOMelement, store) {
        try {
            this.el = DOMelement;
            this.store = store;
            this.listWrapper = this.el.querySelector(".locations-list");
            this.mapEl = this.el.querySelector('[id^="properties-sd-map"]');

            if (this.mapEl) {
                this.viewButtonText = document.querySelector("#hotelViewButtonText");
                this.viewButtonIconMap = document.querySelector("#hotelViewButtonIcon");
                this.viewButtonIconList = document.querySelector("#hotelViewButtonIconList");
                this.mapView = this.el.querySelector("#map-view");
                this.listView = this.el.querySelector("#list-view");
                this.hotelViewButton = document.querySelector("#hotelViewButton");

                this.mobileFilterTags = document.querySelector("#mobile-filter-tags");
                this.mobileFilterButton = document.querySelector(".sd-filter-button");
                this.mobileResultsCount = document.querySelectorAll(".mobile.sd-filter__results-count");

                this.hotelViewButton.addEventListener("click", () => { this.SwitchView(); });

                this.closeAllPopUps = this.closeAllPopUps.bind(this);
                this.onMarkerClick = this.onMarkerClick.bind(this);
                this.onLocationClick = this.onLocationClick.bind(this);
                this.map = new Map(this.mapEl, store, this.onMarkerClick);

                this.onSiteFilters = document.querySelectorAll(".sd-filter-dd, .filter-label-experience ~ .on-site-filter .filter-label, #filter-tags");

                this.data_geo_attr = this.mapEl.getAttribute("data-geo");
                this.scriptID = document.querySelector(`#${this.data_geo_attr}`);
                this.scriptData = this.scriptID.innerText;
                this.mapData = JSON.parse(this.scriptData);
                this.locationsData = this.mapData.geolocations;

                this.locations = this.el.querySelectorAll(".locations-place");
                this.locations.forEach((item, i) => {
                    item.addEventListener("click", (e) =>
                        this.onLocationClick(e.currentTarget, this.locationsData[i])
                    )
                })
                this.addCounterToList();
            }
        } catch (error) {
            console.log(error);
        }
    }

    HideFilters(state) {
        this.onSiteFilters.forEach((filter) => {
            if (state == true) {
                filter.classList.add("hidden");
            } else {
                filter.classList.remove("hidden");
            }
        });

        this.mobileResultsCount.forEach((resultsCount) => {
            if (state == true) {
                resultsCount.style.display = "none";
            } else {
                resultsCount.style.display = "";
            }

        });

        if (state) {
            if (this.mobileFilterButton && this.mobileFilterTags) {
                this.mobileFilterButton.style.display = "none";
                this.mobileFilterTags.style.display = "none";
            }
        } else {
            if (this.mobileFilterButton && this.mobileFilterTags) {
                this.mobileFilterButton.style.display = "";
                this.mobileFilterTags.style.display = "";
            }
        }
    }


    //This is for the Map/List button on hotel list pages to switch the view
    SwitchView() {
        let viewState = document.querySelector("#hotelViewButtonText");
        switch (viewState.innerHTML) {
            case "List view":
                this.mapView.classList.add("hidden");
                this.listView.classList.remove("hidden");

                this.viewButtonIconList.classList.add("hidden");
                this.viewButtonIconMap.classList.remove("hidden");

                this.HideFilters(false);
                this.viewState = "Map view";
                break;
            case "Map view":
                this.mapView.classList.remove("hidden");
                this.listView.classList.add("hidden");

                this.viewButtonIconList.classList.remove("hidden");
                this.viewButtonIconMap.classList.add("hidden");

                this.HideFilters(true);
                this.viewState = "List view";
                break;
            default:
                this.mapView.classList.remove("hidden");
                this.listView.classList.add("hidden");

                this.viewButtonIconList.classList.remove("hidden");
                this.viewButtonIconMap.classList.add("hidden");

                this.HideFilters(false);
                this.viewState = "List view";
                break;
        }
        this.viewButtonText.innerHTML = this.viewState;
    }

    addCounterToList() {
        let listItems = this.listWrapper.querySelectorAll(".locations-place");
        for (const [i, item] of listItems.entries()) {
            item.setAttribute("data-list-counter", i + 1)
        }
    }

    closeAllPopUps() {
        if (this.map.popUps.length) {
            this.map.popUps.forEach((item) => item.remove());
        }
    }

    onMarkerClick(data, idx) {
        this.closeAllPopUps();
        this.locations.forEach((item) => item.classList.remove("active"));
        this.locations[idx].classList.add("active");
        scrollToSelectedLocation(this.locations[idx], this.listWrapper);
        const popupHtml = getPropertiesPopup(data);
        const popup = new this.map.mapbox.Popup({ closeOnClick: false })
            .setLngLat([data.longitude, data.latitude])
            .setHTML(popupHtml);
        this.map.popUps.push(popup);
        popup.addTo(this.map.map);
        popup._closeButton.addEventListener("click", () => {
            this.locations.forEach((item) => item.classList.remove("active"));
        })
        this.map.map.flyTo({
            center: [data.longitude, data.latitude],
            essential: true,
        });
    }

    onLocationClick(el, locationData) {
        this.locations.forEach((item) => item.classList.remove("active"));
        el.classList.add("active");
        let idx = this.locationsData.findIndex(item => item.imageId === locationData.imageId);
        this.onMarkerClick(locationData, idx);
    }

}

export default PropertiesMap;
